// extracted by mini-css-extract-plugin
export default {"title":"_1c31248e6d","bld":"eadcc9963e"};